import React from "react";
import { Link } from "react-router-dom";
import { MdLocationOn, MdInfoOutline, MdChat, MdArrowForward } from "react-icons/md";

const features = [
	{
		icon: <MdLocationOn />,
		tone: "green",
		title: "Locate Residences",
		text: "Locate all the private Hostels and Homestels around KNUST by tapping on the map View or directions to Visit the Residence",
		to: "/hostels",
		cta: "Browse hostels",
	},
	{
		icon: <MdInfoOutline />,
		tone: "amber",
		title: "Complete Information",
		text: "Get All necessary information about your Residences, including Owner's Name, Owner's Contact, etc.",
		to: "/homestels",
		cta: "Browse homestels",
	},
	{
		icon: <MdChat />,
		tone: "teal",
		title: "Raise Your Concerns",
		text: "Send your concerns about a Residences on the comments section or chat directly with the chat Tool kit",
		to: "/help-desk",
		cta: "Visit the help desk",
	},
];

function Descriptions() {
	return (
		<section className="lp-section">
			<div className="container">
				<header className="lp-section-head">
					<span className="lp-kicker">Features</span>
					<h2 className="lp-section-title">What KOSASS brings your way</h2>
					<p className="lp-section-text">
						Get updated on the various Off-Campus hostels/homestel around KNUST
						environs for the next academic year.
					</p>
				</header>
				<div className="lp-features">
					{features.map((item) => (
						<article key={item.title} className="lp-feature">
							<span className={`lp-feature-icon lp-tone-${item.tone}`}>{item.icon}</span>
							<h3 className="lp-feature-title">{item.title}</h3>
							<p className="lp-feature-text">{item.text}</p>
							<Link to={item.to} className="lp-feature-link">
								{item.cta} <MdArrowForward />
							</Link>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}

export default Descriptions;
